import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appTelNumberOnly]',
})
export class TelNumberOnlyDirective {
  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('input', ['$event']) onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    let sanitizedValue = input.value.replace(/[^0-9]/g, '');

    if (sanitizedValue.length > 10) {
      sanitizedValue = sanitizedValue.slice(0, 10);
    }

    this.control.control?.setValue(sanitizedValue);
  }
}
